export default __webpack_public_path__ + "static/media/warning--keep-distance--g1.18012af6.png";